"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var simple_crypto_js_1 = __importDefault(require("simple-crypto-js"));
/**
 * Provides an interface to store object data in the application storage.
 * It also allows the data to be encrypted to prevent basic tampering.
 */
var AppStorageClass = /** @class */ (function () {
    /**
     * Create the local storage
     * @param storageName {String} The name of the storage key
     * @param encryptionKey {String} The encryption key to use if any.
     */
    function AppStorageClass(storageName, encryptionKey) {
        this.crypto = null;
        this.storageName = storageName;
        if (encryptionKey !== null) {
            this.crypto = new simple_crypto_js_1.default(encryptionKey);
        }
    }
    /**
     * Sets a value on the storage object.
     * @param key {String} The string to store
     * @param value {*} Anything that needs to be stored
     */
    AppStorageClass.prototype.set = function (key, value) {
        var store = this.unpack();
        store[key] = value;
        this.pack(store);
    };
    /**
     * Gets a value from the store, can return undefined if
     * @param key
     */
    AppStorageClass.prototype.get = function (key) {
        var store = this.unpack();
        return store[key];
    };
    /**
     * Checks if a key exists on the store.
     * @param key {string} the key of the item
     */
    AppStorageClass.prototype.exists = function (key) {
        var store = this.unpack();
        return store.hasOwnProperty(key);
    };
    /**
     * Remove a node from the store
     * @param key {String} the item to remove
     */
    AppStorageClass.prototype.remove = function (key) {
        if (this.exists(key)) {
            var store = this.unpack();
            delete store[key];
            this.pack(store);
            return true;
        }
        return false;
    };
    /**
     * Clears and resets the local storage.
     */
    AppStorageClass.prototype.clear = function () {
        this.pack({});
    };
    /**
     * Generates a hash of the object store
     * @returns {number} the hash of the store.
     */
    AppStorageClass.prototype.hash = function () {
        var hash = 0;
        var i;
        var chr;
        var val = localStorage.getItem(this.storageName);
        if (val === null || val.length === 0) {
            return hash;
        }
        for (i = 0; i < val.length; i++) {
            chr = val.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };
    /**
     * Packs up the object payload and stores it in the local storage
     * @param object {Object} the object to store.
     */
    AppStorageClass.prototype.pack = function (object) {
        var payload = JSON.stringify(object);
        if (this.crypto !== null) {
            try {
                payload = this.crypto.encrypt(JSON.stringify(object));
            }
            catch (err) {
                // Do nothing
            }
        }
        localStorage.setItem(this.storageName, payload);
    };
    /**
     * Unpacks the localStorage and decrypts it if its encrypted
     * @returns {Object} The decrypted expanded storage object.
     */
    AppStorageClass.prototype.unpack = function () {
        var val = "";
        try {
            val = localStorage.getItem(this.storageName);
        }
        catch (err) {
            return {};
        }
        if (val === null) {
            return {};
        }
        try {
            if (this.crypto !== null) {
                // @ts-ignore
                return JSON.parse(this.crypto.decrypt(val));
            }
            else {
                return JSON.parse(val);
            }
        }
        catch (err) {
            return {};
        }
    };
    return AppStorageClass;
}());
exports.default = AppStorageClass;
//# sourceMappingURL=data:application/json;base64,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